import { QuoteDetails } from '@domgen/dgx-fe-basket';
import { RegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.interface';

export interface ProtectionAdditionalQuoteModalResult {
  applianceDetails: RegistrationApplianceDetails;
  quoteDetails?: QuoteDetails;
}
